import { useContext } from "react";

import styled from "styled-components";

import FnrLoadingBricks from "UI/FnrLoadingBricks2/FnrLoadingBricks";
import FnrSlides from "UI/FnrSlides";
import FnrStaggeredEntry from "UI/FnrStaggeredEntry";
import { colors } from "UI/colors";

import { FnrTabsContext } from "./FnrTabs";

const Content = () => {
  const { activeKey, tabs, isLoading, clip } = useContext(FnrTabsContext);

  return (
    // outer div shields from parents with gap.
    <div>
      <FnrStaggeredEntry show variant="fade">
        {isLoading && <Loader key="loader" />}
        {!isLoading && (
          <FnrSlides
            key="content"
            fullWidth
            components={tabs.map(({ content, key }) => ({
              value: content,
              key,
            }))}
            activeKey={activeKey}
            hideHeightMotion={true}
            clip={clip}
          />
        )}
      </FnrStaggeredEntry>
    </div>
  );
};

const Loader = () => (
  <LoadingBricksContainer>
    <FnrLoadingBricks loading size={28} color={colors.fnBlue700} />
  </LoadingBricksContainer>
);

const LoadingBricksContainer = styled.div`
  width: 100%;
  max-width: 460px;
  display: grid;
  place-content: center;
  align-content: center;
  justify-content: center;
  min-height: 100px;
`;

export default Content;
